import { Component } from '@angular/core';

@Component({
  selector: 'rnpl-column-placeholder',
  templateUrl: './column-placeholder.component.html',
  styleUrls: ['./column-placeholder.component.scss']
})
export class ColumnPlaceholderComponent {
}
